module.exports = __webpack_public_path__ + "img/icon-mail.3d216c86.svg";